module.exports = __webpack_public_path__ + "img/官网-证书-云指课堂教学资源系统.2bc50f11.png";